
import React, { PureComponent } from 'react';
import Webcam from "react-webcam";
import PropTypes            from 'prop-types';
import cx                   from 'classnames';
import { withRouter }       from 'react-router-dom';

const WebcamComponent = () => <Webcam />;


class WebcamCapture extends PureComponent {
  setRef = webcam => {
    this.webcam = webcam;
  };

  capture = () => {
    const imageSrc = this.webcam.getScreenshot();
    this.props.callback(imageSrc);
  };

  render() {
    const videoConstraints = {
      width: 'auto',
      height: 'auto',
      facingMode: "environment"
    };

    return (
      <div >
        <Webcam
          audio={false}
          height={150}
          ref={this.setRef}
          screenshotFormat="image/jpeg"
          width={275}
          videoConstraints={videoConstraints}
        />
        <div>
        <input type="button" style={{marginTop:'1%'}} className="button1" onClick={this.capture} value="Capture photo" />
        </div>
      </div>
    );
  }
}

export default withRouter(WebcamCapture);
                    


// WEBPACK FOOTER //
// ./src/app/components/reactCamera/reactCamera.js